import { useLocation, useNavigate } from 'react-router-dom';
import ErrorMessage from '../../components/error-message';
import styles from '../choose-apartment-complex/styles.module.scss';
import Loader from '../../components/loader';
import { Virtuoso } from 'react-virtuoso';
import { ITEMS_PER_PAGE } from '../../lib/constants';
import { APARTMENT_LIST_ITEM_HEIGHT } from '../../components/apartment-list-item';
import { BuyApartmentFlowPaths } from '../../routes';
import { ApartmentNavigateProps } from '../apartment';
import clsx from 'clsx';
import LoadMoreVirtualListFooter from '../../components/load-more-virtual-list-footer';
import NotFound from '../../components/not-found';
import BaseScreen, { BASE_SCREEN_HEADER_HEIGHT } from '../../components/base-screen';
import { APIUserType, MarketTypes } from '../../api/types';
import iconDelete from 'assets/images/icon-delete-cross.svg';
import FavoritesFacilityListItem from '../../components/favorites-facility-list-item';
import useFavoritesList from 'api/hooks/use-favorites-facility-list';
import useBoundStore from 'store';
import iconThreeDots from 'assets/images/three-dots.svg';

const FavoritesFacilityList = () => {
  const navigate = useNavigate();
  const favoriteId = (useLocation().state as ApartmentNavigateProps)?.id;
  const listStyle = { height: `calc(100vh - ${BASE_SCREEN_HEADER_HEIGHT})` };
  const {
    error,
    total,
    data: facility,
    setSize,
    isLoadingMore,
    isInitialLoading,
    mutate,
  } = useFavoritesList(favoriteId);

  const refetchList = () => {
    mutate();
  };

  const user = useBoundStore((s) => s.user);
  const isClient = user?.type === APIUserType.CLIENT;

  return (
    <BaseScreen title='Избранные обьекты'>
      {error && facility.length === 0 ? (
        <ErrorMessage className={styles.margined} message={error} />
      ) : isInitialLoading ? (
        <Loader className={styles.margined} />
      ) : facility.length > 0 ? (
        <Virtuoso
          useWindowScroll
          context={{
            total,
            loading: isLoadingMore,
            per: ITEMS_PER_PAGE,
            loadedNum: facility.length,
            loadMore: () => setSize((s) => s + 1),
          }}
          data={facility}
          style={listStyle}
          className={styles.container}
          defaultItemHeight={APARTMENT_LIST_ITEM_HEIGHT}
          itemContent={(index, apartment) => {
            return (
              <FavoritesFacilityListItem
                {...apartment}
                onClick={() =>
                  navigate(
                    apartment?.marketType === MarketTypes.SECONDARY
                      ? BuyApartmentFlowPaths.apartmentSecondary
                      : BuyApartmentFlowPaths.apartment,
                    {
                      state: { id: apartment?.id } as ApartmentNavigateProps,
                    },
                  )
                }
                hasNote={apartment.hasNote}
                icon={<img src={isClient ? iconDelete : iconThreeDots} alt='delete' />}
                isClient={isClient}
                className={clsx(index !== 3 - 1 && styles.border)}
                favoriteId={favoriteId}
                facilityId={apartment.id}
                refetchList={refetchList}
              />
            );
          }}
          components={{ Footer: LoadMoreVirtualListFooter }}
        />
      ) : (
        <NotFound />
      )}
    </BaseScreen>
  );
};
export default FavoritesFacilityList;
